<template>
  <vs-chip class="ag-grid-cell-chip" :color="statusColor">
    <span>{{ statusText }}</span>
  </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererGiftSetsRequestStatus',
  props: {
    status: {
      type: String,
      default: null
    }
  },
  computed: {
    statusText() {
      return this.lodash.startCase(this.status)
    },
    statusColor() {
      let color = 'primary'
      switch (this.status) {
        case 'waiting':
          color = 'warning'
          break

        case 'approved':
        case 'process':
        case 'completed':
          color = 'success'
          break

        case 'rejected':
        case 'canceled':
          color = 'danger'
          break
      }

      return color
    }
  }
}
</script>

<style lang="scss" scoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success), 0.15);
    color: rgba(var(--vs-success), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning), 0.15);
    color: rgba(var(--vs-warning), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger), 0.15);
    color: rgba(var(--vs-danger), 1) !important;
    font-weight: 500;
  }
}
</style>
